"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shakeTranslateX = exports.shakeTransitionConfig = exports.pulseVariantOpacity = exports.pulseTransitionConfig = exports.colorSurgeExitConfig = exports.colorSurgeEnterConfig = void 0;
var _tokens = require("./tokens");
const colorSurgeEnterConfig = (0, _tokens.createMotionConfig)('fadeIn30', 'fast1');
exports.colorSurgeEnterConfig = colorSurgeEnterConfig;
const colorSurgeExitConfig = (0, _tokens.createMotionConfig)('fadeOut30', 'slow4', {
  delay: 200
});
exports.colorSurgeExitConfig = colorSurgeExitConfig;
const shakeTranslateX = [0, -8, 8, -6, 6, -4, 4, -2, 2, 0];
exports.shakeTranslateX = shakeTranslateX;
const shakeTransitionConfig = {
  easing: 'enterFunctional',
  duration: 'slow2'
};
exports.shakeTransitionConfig = shakeTransitionConfig;
const pulseTransitionConfig = {
  easing: 'linear',
  oneOffDuration: 2000
};
exports.pulseTransitionConfig = pulseTransitionConfig;
const pulseVariantOpacity = {
  moderate: 0.7,
  subtle: 0.9,
  heavy: 0.5
};
exports.pulseVariantOpacity = pulseVariantOpacity;